// extracted by mini-css-extract-plugin
export default {"layoutsMain":"style_layoutsMain__ttqI-","layoutsMainAbout":"style_layoutsMainAbout__Ck51j","layoutsMainContentInfo":"style_layoutsMainContentInfo__89FI9"};